export const contactTranslations = {
    contactUs: {
      title: "اتصل بنا",
      description: "هل لديك أسئلة أو تحتاج إلى مساعدة؟ فريقنا هنا لمساعدتك في أي استفسارات حول خدماتنا أو مجتمعنا.",
      form: {
        title: "تواصل معنا",
        firstName: "الاسم الأول *",
        lastName: "الاسم الأخير *",
        email: "عنوان البريد الإلكتروني *",
        phone: "رقم الهاتف",
        subject: "الموضوع *",
        message: "الرسالة *",
        consent: "أوافق على سياسة الخصوصية وأوافق على الاتصال بي بشأن استفساري.",
        sendMessage: "إرسال الرسالة"
      },
      contactInfo: {
        title: "معلومات الاتصال",
        email: {
          title: "البريد الإلكتروني",
          emails: ["info@qualitynexus.com", "support@qualitynexus.com"]
        },
        phone: {
          title: "الهاتف",
          numbers: ["+1 (555) 123-4567", "+1 (555) 987-6543"]
        },
        businessHours: {
          title: "ساعات العمل",
          hours: [
            "الاثنين - الجمعة: 9:00 صباحًا - 6:00 مساءً (بتوقيت شرق الولايات المتحدة)",
            "السبت والأحد: مغلق"
          ]
        }
      },
      urgentAssistance: {
        title: "هل تحتاج إلى مساعدة عاجلة؟",
        description: "فريق الدعم لدينا متاح للطلبات العاجلة والاستشارات.",
        liveChat: "الدردشة الحية متاحة",
        buttonText: "بدء الدردشة الحية"
      },
      faq: {
        title: "الأسئلة المتداولة",
        questions: [
          {
            question: "ما هي خدمات الاختبار التي تقدمها Quality Nexus؟",
            answer: "تقدم Quality Nexus مجموعة شاملة من خدمات الاختبار بما في ذلك الاختبار الوظيفي، اختبار الأتمتة، اختبار الأداء، اختبار الأمان، اختبار قابلية الاستخدام، اختبار واجهة برمجة التطبيقات (API)، استشارات الجودة، تصميم استراتيجيات الاختبار، واختبار الوصول."
          },
          {
            question: "كيف يمكنني الانضمام إلى مجتمع Quality Nexus؟",
            answer: "يمكنك الانضمام إلى مجتمع Quality Nexus من خلال إنشاء حساب مجاني في صفحة المجتمع الخاصة بنا. يتيح لك ذلك المشاركة في التحديات، والتواصل مع المرشدين، وحضور الفعاليات، وعرض خبراتك في الاختبار."
          },
          {
            question: "هل يمكنني طلب حل اختبار مخصص لمشروعي؟",
            answer: "نعم، نقدم حلول اختبار مخصصة تناسب متطلبات مشروعك المحددة. تواصل معنا مع تفاصيل مشروعك، وسنعمل معك لتطوير استراتيجية اختبار تلبي احتياجاتك."
          },
          {
            question: "كم من الوقت يستغرق بدء العمل على مشروع اختبار جديد؟",
            answer: "تستغرق عملية الانضمام النموذجية لدينا من أسبوع إلى أسبوعين، حسب تعقيد المشروع. بالنسبة للاحتياجات العاجلة، نقدم أيضًا خدمات سريعة. تواصل معنا لمناقشة متطلبات الجدول الزمني."
          }
        ],
        viewAll: "عرض جميع الأسئلة المتداولة"
      }
    }
  };
  